import React, { useEffect } from 'react';
import { AppRouter } from './AppRouter';
import { PasswordProtection } from './components/auth/PasswordProtection';
export function App() {
  useEffect(() => {
    document.title = 'Mint';
  }, []);
  return <PasswordProtection data-id="element-0">
      <AppRouter data-id="element-1" />
    </PasswordProtection>;
}